export enum SecurityType {
    STOCK = 'STOCK',
    BOND = 'BOND',
    ETF = 'ETF',
    FUND = 'FUND',
    GOLD = 'GOLD'
}